// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import settings04Icon from "@/assets/icons/settings-04.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Settings04IconProps = Omit<IconProps, "name">;

export function Settings04Icon(props: Settings04IconProps): React.ReactNode {
  return <Icon name={settings04Icon} {...props} />;
}
